import React from "react";
import moment from "jalali-moment";

function convertJalaliToMiladi(props) {
  const miladiMoment = moment(props, "jYYYY/jMM/jDD");
  const miladiDateFormatted = miladiMoment.format("YYYY/MM/DD");
  return miladiDateFormatted;
}

export default convertJalaliToMiladi;
